export default {
  nav: {
    auction: "Leilão Público",
    ecosystem: "O Ecossistema",
    areas: "Áreas do Projeto",
    naming: "Naming Rights & Alianças",
    contact: "Contato Privado",
    cta: "Solicitar Dossiê Confidencial",
  },
  hero: {
    eyebrow: "Montalbán · Caracas · Venezuela",
    badge: "Fundación Deportiva Disimil",
    lines: [
      "O Novo Epicentro",
      "do Esporte, da Saúde",
      "e da Formação",
      "Profissional em Caracas",
    ],
    subtitle:
      "Uma aliança estratégica em Montalbán que transforma o território em um complexo de alto rendimento, educação técnica superior e medicina preventiva.",
    ctaPrimary: "Oportunidades de Naming Rights",
    ctaSecondary: "Explorar as Áreas",
    scroll: "Role",
  },
  marquee: [
    "Naming Rights Disponíveis",
    "Montalbán · Caracas",
    "Centro de Alto Rendimento",
    "Academia Esportiva Mcintosh",
    "Instituto de Estudos Superiores do Esporte",
    "Crioterapia & Hidroterapia",
    "Leilão Público de Naming",
    "Fundación Deportiva Disimil",
  ],
  eco: {
    chapter: "01",
    label: "O Ecossistema",
    title: "Um ecossistema quadripartido. Quatro frentes de investimento.",
    subtitle:
      "Quatro instituições integradas sob uma única governança, cada uma com oportunidades exclusivas de vinculação corporativa.",
    opportunityLabel: "Oportunidade de vinculação",
    cards: [
      {
        num: "01",
        category: "Infraestrutura Atlética",
        title: "Centro de Alto Rendimento Esportivo Montalbán",
        desc: "Campo principal de grama sintética, torres de iluminação LED noturna, vestiários profissionais e academia de alto rendimento.",
        opportunity: "Naming Rights Principal do Complexo",
        badge: "Eixo Esportivo",
        testid: "ecosystem-card-alto-rendimiento",
      },
      {
        num: "02",
        category: "Formação de Base",
        title: "Academia Esportiva Mcintosh",
        desc: "Academia de formação esportiva integral para centenas de crianças e jovens atletas da comunidade.",
        opportunity: "Padrinho da Base e Uniformes",
        badge: "Eixo Formativo",
        testid: "ecosystem-card-mcintosh",
      },
      {
        num: "03",
        category: "Formação Acadêmica",
        title: "Instituto de Estudos Superiores do Esporte Venezuela",
        desc: "Salas inteligentes de certificação para treinadores, árbitros e gestores esportivos de todo o país.",
        opportunity: "Patrocinador Acadêmico Titular",
        badge: "Eixo Educacional",
        testid: "ecosystem-card-instituto",
      },
      {
        num: "04",
        category: "Saúde & Terapia",
        title: "Centro de Reabilitação Esportiva Disimil",
        desc: "Consultórios médicos, salas de terapia física, fisioterapia avançada e salas especializadas de crioterapia e hidroterapia.",
        opportunity:
          "Naming da Área de Saúde — ideal para clínicas, seguradoras e farmacêuticas",
        badge: "Eixo Médico",
        testid: "ecosystem-card-rehabilitacion",
      },
    ],
  },
  trans: {
    chapter: "02",
    label: "Áreas do Projeto",
    statement: "De um espaço em desuso a um ícone continental.",
    title: "O ponto de partida: um território com história, pronto para renascer",
    subtitle:
      "Registro atual do complexo em Montalbán. Este material — capturado no local — mostra a magnitude do espaço que o plano diretor transformará em fases.",
    videoLabel: "Registro em vídeo",
    videoCaption: "Assim está hoje o complexo — vídeo registrado no local, Montalbán",
    captions: [
      "Vista aérea do terreno — setor norte",
      "Vista aérea do terreno — setor sul",
      "Campo principal — estado atual",
      "Campo de terra — treinos atuais",
    ],
    note: "Plano diretor por fases: recuperação do campo principal, torres de LED, pavilhão clínico e salas do instituto. As especificações técnicas estão detalhadas no Dossiê Executivo.",
  },
  plan: {
    chapter: "03",
    label: "Plano Diretor",
    title: "O plano diretor: assim pode ficar o complexo",
    subtitle:
      "Plano conceitual original do projeto. Nove zonas planejadas no terreno de Montalbán — cada uma com naming individual disponível.",
    mapCaption: "Plano conceitual — design original do projeto",
    zonesTitle: "Zonas do plano diretor",
    zones: [
      {
        name: "Campo 1",
        desc: "Campo principal de grama sintética com torres de iluminação LED noturna.",
      },
      {
        name: "Campo 2",
        desc: "Segundo campo regulamentar para treinos e torneios simultâneos.",
      },
      {
        name: "Centro de Estudos",
        desc: "Sede do Instituto de Estudos Superiores do Esporte Venezuela.",
      },
      {
        name: "Centro Terapêutico",
        desc: "Salas de fisioterapia, crioterapia e hidroterapia do Centro de Reabilitação Disimil.",
      },
      {
        name: "Centro Médico",
        desc: "Consultórios médicos e atendimento esportivo especializado.",
      },
      {
        name: "Academia",
        desc: "Academia de alto rendimento e preparação biomecânica.",
      },
      {
        name: "Escritórios",
        desc: "Sede administrativa da Fundación Deportiva Disimil e da Mesa Técnica.",
      },
      {
        name: "Lanchonete",
        desc: "Área de convivência e hospitalidade para atletas, famílias e visitantes corporativos.",
      },
      {
        name: "Estacionamento",
        desc: "Estacionamento para atletas, equipe médica e visitantes.",
      },
    ],
    note: "Cada zona admite naming individual, patrocínio de equipamento ou adoção completa por fase.",
  },
  naming: {
    chapter: "04",
    label: "Naming Rights & Alianças",
    title: "Vincule o nome da sua marca a um legado histórico",
    subtitle:
      "Modelos de associação institucional desenhados para maximizar o retorno reputacional. Sem cifras públicas: as condições são reservadas à mesa executiva.",
    closing:
      "As condições, especificações de retorno publicitário e pliegos técnicos são entregues de forma privada em reunião executiva.",
    packages: [
      {
        badge: "Oportunidade Principal",
        title: "Naming Rights Titular do Complexo",
        framing: "Leilão público · encerra 31 dez 2026",
        highlights: [
          "Direito de batizar todo o complexo: 'Complexo Esportivo [Sua Marca]'",
          "Presença monumental na fachada principal e no círculo central do campo",
          "Marca em credenciamentos, transmissões e papelaria oficial",
          "Preferência em eventos e turnês de mídia do complexo",
        ],
        cta: "Participar do Leilão Confidencial",
        testid: "pkg-naming-titular",
      },
      {
        badge: "Setor Saúde & Seguros",
        title: "Naming do Pavilhão Clínico e Sala de Crioterapia",
        framing: "Ideal para clínicas, seguradoras e farmacêuticas",
        highlights: [
          "Presença de marca na área médica de recuperação física",
          "Naming das salas de crioterapia e hidroterapia",
          "Visibilidade direta perante atletas de elite e pacientes privados",
          "Convênios preferenciais de atendimento para executivos aliados",
        ],
        cta: "Solicitar o Dossiê da Área de Saúde",
        testid: "pkg-naming-clinico",
      },
      {
        badge: "Educação Corporativa",
        title: "Padrinho Acadêmico do Instituto",
        framing: "Liderança na formação esportiva nacional",
        highlights: [
          "Presença de marca em salas e laboratórios de certificação",
          "Marca nos certificados técnicos oficiais emitidos pelo instituto",
          "Programa de bolsas corporativas com o nome da sua organização",
          "Co-organização de congressos e jornadas técnicas",
        ],
        cta: "Agendar a Apresentação Acadêmica",
        testid: "pkg-padrino-academico",
      },
      {
        badge: "Construtoras & Marcas",
        title: "Aliados Técnicos e Doações em Espécie",
        framing: "Materiais de construção e equipamento",
        highlights: [
          "Acordos com empresas de construção, iluminação, cabeamento, aço, cimento e tintas",
          "Reconhecimento permanente como Aliado Construtor na placa de honra",
          "Certificação de contribuição de Responsabilidade Social Empresarial",
          "Visibilidade nas áreas técnicas durante a construção e operação",
        ],
        cta: "Coordenar Aporte em Espécie",
        testid: "pkg-aliados-tecnicos",
      },
    ],
  },
  auction: {
    "chapter": "05",
    "label": "Leilão Público de Naming Rights",
    "title": "O nome do complexo, em leilão público",
    "subtitle": "Direitos de nome por 10 anos. A empresa ou pessoa com a melhor oferta no encerramento batizará o Centro de Alto Rendimento Esportivo Montalbán.",
    "closesLabel": "Encerramento do leilão",
    "closesDate": "31 de dezembro de 2026 · 18h00 (hora da Venezuela)",
    "days": "Dias",
    "hours": "Horas",
    "minutes": "Min",
    "seconds": "Seg",
    "leaderLabel": "Licitante líder",
    "noBids": "Ainda sem ofertas — seja o primeiro",
    "bidsLabel": "Ofertas recebidas",
    "biddersLabel": "Licitantes validados",
    "termLabel": "Vigência",
    "termValue": "10 anos",
    "rulesTitle": "Regras do leilão",
    "rules": [
      "Participam apenas licitantes previamente validados pela Mesa Técnica.",
      "Os valores são confidenciais: apenas licitantes validados e a Mesa Técnica os conhecem. O público vê apenas o licitante líder e o número de ofertas.",
      "Cada licitante escolhe aparecer com seu nome/empresa ou com um alias.",
      "Regra anti-encerramento: qualquer oferta nos últimos 10 minutos prolonga o leilão por mais 10 minutos.",
      "O vencedor formaliza contrato com a Fundação e realiza o aporte por transferência bancária, sob auditoria internacional."
    ],
    "videoLabel": "Assim se faz no mundo",
    "videoTitle": "Estádios e arenas que levam o nome de uma marca",
    "videoNote": "Allianz Arena, Emirates Stadium, Etihad Stadium, Mercedes-Benz Stadium, Estadio BBVA, Allianz Parque: marcas globais que transformaram um recinto esportivo em sua maior vitrine. Montalbán abre a mesma oportunidade na Venezuela.",
    "ctaRegister": "Registrar-me como Licitante",
    "ctaEnter": "Entrar no Portal",
    "closed": "Leilão encerrado",
    "open": "Leilão aberto"
  },
  portal: {
    "back": "Voltar ao site",
    "title": "Portal de Licitantes",
    "subtitle": "Leilão Público de Naming Rights · Complexo Montalbán",
    "login": "Entrar",
    "register": "Registrar-me",
    "name": "Nome completo",
    "company": "Empresa (opcional)",
    "email": "E-mail",
    "phone": "Telefone / WhatsApp",
    "password": "Senha (mín. 8 caracteres)",
    "displayMode": "Como deseja aparecer publicamente?",
    "showName": "Meu nome ou empresa",
    "showAlias": "Um alias (Licitante #NN)",
    "submitLogin": "Entrar",
    "submitRegister": "Enviar solicitação de registro",
    "logout": "Sair",
    "pendingTitle": "Registro em validação",
    "pendingDesc": "A Mesa Técnica está verificando sua solicitação. Você receberá um e-mail quando for aprovado e puder ofertar.",
    "rejectedTitle": "Registro não aprovado",
    "rejectedDesc": "Sua solicitação não foi validada. Se acredita que é um erro, escreva-nos pelo formulário de contato.",
    "yourAlias": "Seu identificador público",
    "highBid": "Oferta líder atual",
    "minNext": "Oferta mínima seguinte",
    "noHigh": "Sem ofertas ainda",
    "leading": "Você lidera o leilão",
    "outbid": "Sua oferta foi superada",
    "notBid": "Você ainda não ofertou",
    "bidLabel": "Sua oferta (USD)",
    "placeBid": "Apresentar oferta",
    "confirm": "Confirma sua oferta de {amount} USD? Ela é vinculante.",
    "bidOk": "Oferta registrada",
    "extended": "O leilão foi prolongado (regra anti-encerramento).",
    "history": "Histórico de ofertas",
    "mine": "Você",
    "closed": "O leilão encerrou. Obrigado por participar.",
    "closesIn": "Encerra em",
    "welcome": "Bem-vindo",
    "statusApproved": "Licitante validado"
  },
  gov: {
    chapter: "06",
    label: "Governança",
    title: "Governança e transparência de primeiro mundo",
    subtitle:
      "Cada aporte é administrado sob supervisão técnica, auditoria internacional e prestação de contas institucional.",
    features: [
      {
        title: "Fundación Deportiva Disimil",
        desc: "Entidade jurídica e órgão reitor do projeto: supervisão técnica e gestão institucional.",
      },
      {
        title: "Auditoria por ONG Internacional",
        desc: "Todos os fundos do projeto serão auditados por uma ONG internacional independente, com prestação de contas periódica aos aliados.",
      },
      {
        title: "Mesa Técnica Executiva",
        desc: "Engenheiros, médicos do esporte e gerentes de projeto supervisionam cada fase do plano diretor.",
      },
      {
        title: "Uso Exclusivo dos Aportes",
        desc: "Cada contribuição — em divisas ou em espécie — destina-se exclusivamente ao desenvolvimento e operação do complexo.",
      },
    ],
  },
  contrib: {
    chapter: "07",
    label: "Como Contribuir",
    title: "Canal oficial de contribuição",
    subtitle: "Aportes diretos, rastreáveis e auditados. Sem intermediários.",
    bankTitle: "Depósito ou Transferência Bancária",
    bankDesc:
      "As coordenadas bancárias oficiais em dólares (USD) são entregues junto ao Dossiê Executivo Confidencial, uma vez validada a solicitação da sua organização.",
    bankFields: [
      "Banco correspondente",
      "Titular: Fundación Deportiva Disimil",
      "Conta em dólares (USD)",
      "Referência: Projeto Complejo Montalbán",
    ],
    bankCta: "Solicitar Coordenadas Bancárias",
    kindTitle: "Doação em Espécie",
    kindDesc:
      "Materiais de construção, iluminação LED, aço, cimento, tintas, grama sintética e equipamento médico ou esportivo.",
    kindCta: "Coordenar Doação em Espécie",
    auditNote:
      "Todos os aportes — monetários e em espécie — são auditados por uma ONG internacional e reportados a cada aliado.",
  },
  donate: {
    badge: "Pagamento seguro com cartão",
    title: "Doação com Cartão",
    desc: "Aporte direto, seguro e rastreável em dólares. Processado pela Stripe, com certificação internacional de segurança de pagamentos.",
    once: "Doação Única",
    monthly: "Aliado Mensal",
    monthlyHint: "Cobrança recorrente todo mês. Pode ser cancelada a qualquer momento.",
    amountLabel: "Selecione um valor (USD)",
    custom: "Outro valor",
    customPlaceholder: "Valor em USD",
    nameLabel: "Nome ou empresa (opcional)",
    namePlaceholder: "Como deseja aparecer no Muro de Aliados",
    emailLabel: "E-mail (para o seu recibo)",
    emailPlaceholder: "nome@empresa.com",
    anonymous: "Desejo que minha doação seja anônima",
    anonymousHint: "Seu nome não será exibido publicamente. O recibo é enviado ao seu e-mail.",
    cta: "Doar com Cartão",
    ctaMonthly: "Tornar-me Aliado Mensal",
    redirecting: "Redirecionando ao pagamento seguro…",
    error: "Não foi possível iniciar o pagamento. Tente novamente.",
    amountError: "Informe um valor válido entre 5 e 25.000 USD.",
    secure: "Criptografia SSL · Os dados do seu cartão nunca passam pelos nossos servidores",
    wallLabel: "Muro de Aliados",
    wallTitle: "Quem já constrói Montalbán",
    wallEmpty: "Seja o primeiro nome neste muro.",
    wallAnon: "aportes anônimos",
    wallMonthly: "Aliado Mensal",
    wallCorporate: "Empresas aliadas que já contribuíram",
    wallIndividual: "Aliados individuais",
    wallOnce: "Aliado",
  },
  payment: {
    checking: "Confirmando seu aporte…",
    successTitle: "Obrigado por construir Montalbán",
    successDesc: "Seu aporte foi recebido e ficará registrado sob auditoria internacional. O comprovante foi enviado ao seu e-mail.",
    successMonthly: "Bem-vindo como Aliado Mensal do Complexo Montalbán.",
    pendingTitle: "Pagamento em processamento",
    pendingDesc: "Seu banco está confirmando a operação. Avisaremos por e-mail quando for concluída.",
    failTitle: "Não conseguimos confirmar o pagamento",
    failDesc: "A sessão expirou ou o pagamento não foi concluído. Você pode tentar novamente.",
    cancelTitle: "Pagamento cancelado",
    cancelDesc: "Nenhuma cobrança foi realizada. Quando desejar, pode retomar seu aporte.",
    back: "Voltar ao site",
    retry: "Tentar novamente",
  },
  contact: {
    chapter: "08",
    label: "Contato Privado",
    title: "Agende uma apresentação com a Mesa Técnica",
    subtitle:
      "Toda solicitação é tratada sob estrito acordo de confidencialidade. Resposta executiva garantida.",
    name: "Nome do Representante",
    company: "Empresa ou Instituição",
    email: "E-mail Corporativo",
    phone: "Telefone Direto / WhatsApp",
    interest: "Área de Interesse",
    interestPlaceholder: "Selecione uma área",
    interests: [
      "Naming Geral do Complexo (Leilão)",
      "Área de Saúde / Crioterapia",
      "Área Acadêmica / Instituto",
      "Doação de Materiais de Construção",
      "Aliança Geral / Outro",
    ],
    message: "Comentários adicionais (opcional)",
    submit: "Agendar Apresentação com a Mesa Técnica",
    submitting: "Enviando solicitação…",
    success:
      "Solicitação enviada com sucesso. A Mesa Técnica entrará em contato em breve sob acordo de confidencialidade.",
    error: "Não foi possível enviar a solicitação. Tente novamente.",
    privacy:
      "Suas informações são usadas exclusivamente para a gestão das alianças institucionais do projeto.",
  },
  footer: {
    entity: "Fundación Deportiva Disimil",
    project: "Centro de Alto Rendimento Esportivo Montalbán",
    location: "Montalbán, Município Libertador, Caracas, Venezuela",
    confidentiality:
      "Documentação reservada exclusivamente a aliados corporativos e institucionais.",
    navTitle: "Índice",
    masterplan: "Plano Diretor",
    governance: "Governança",
    contribute: "Como Contribuir",
    rights: "© 2026 Fundación Deportiva Disimil. Todos os direitos reservados.",
  },
};
